import React from 'react';

export default function SvgDeactivateEmail(props) {
  return (
    <svg
      width="279"
      height="306"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 279 306">
      <path
        d="M213.759 232.644C219.124 243.59 219.921 257.541 216.709 269.868C201.214 264.788 189.85 256.888 183.868 247.165C177.885 237.441 177.275 225.875 183.327 213.437C198.438 213.739 208.388 221.687 213.759 232.644Z"
        fill="#DBDBDB"
        stroke="#C0C0C0"
        strokeWidth="0.25"
      />
      <path
        d="M221.134 173.656L221.134 173.656C222.124 176.179 222.113 178.26 221.301 179.945C220.487 181.633 218.857 182.948 216.56 183.909C211.962 185.834 204.75 186.323 196.306 185.609C190.897 185.153 184.856 181.855 180.114 177.324C175.372 172.792 171.956 167.05 171.763 161.727C171.57 156.404 173.883 152.978 176.033 150.151C176.206 149.924 176.378 149.7 176.548 149.479C177.432 148.33 178.254 147.262 178.804 146.189C179.463 144.902 179.739 143.596 179.27 142.117C178.805 140.651 177.732 139.188 176.417 137.696C175.674 136.852 174.844 135.99 173.997 135.11C173.351 134.439 172.695 133.757 172.06 133.066C169.106 129.85 166.563 126.373 167.104 122.352C167.589 118.767 169.367 116.544 171.804 115.054C174.25 113.559 177.361 112.802 180.512 112.166C181.045 112.058 181.58 111.954 182.112 111.85C184.716 111.342 187.27 110.844 189.389 109.999C191.948 108.98 193.901 107.445 194.549 104.756C195.835 99.4228 193.167 95.9133 190.327 92.4885C190.193 92.3271 190.059 92.166 189.925 92.0048C187.203 88.7351 184.486 85.47 184.877 80.657C184.979 79.4 185.353 78.4183 185.936 77.6373C186.52 76.8556 187.318 76.2677 188.28 75.8074C190.202 74.8873 192.75 74.4875 195.48 74.0593L195.509 74.0547C200.964 73.1989 207.12 72.2276 210.03 66.6122C212.902 61.0715 218.459 52.9771 224.687 47.645C227.802 44.9785 231.073 43.0121 234.252 42.3922C237.422 41.774 240.506 42.4929 243.269 45.2144C245.458 47.3716 246.182 49.3367 246.072 51.1483C245.962 52.9673 245.011 54.6579 243.794 56.2609C243.186 57.0613 242.515 57.8361 241.854 58.5916C241.797 58.6562 241.741 58.7207 241.684 58.7851C241.083 59.472 240.494 60.1438 239.98 60.8009C238.86 62.231 238.06 63.6287 238.26 65.009C238.673 67.8539 240.597 69.3442 242.454 70.7817C242.607 70.9001 242.759 71.0181 242.91 71.1365C243.908 71.9186 244.849 72.7161 245.512 73.739C246.173 74.7576 246.561 76.0061 246.44 77.6966C246.097 82.4892 242.781 85.3527 239.594 88.0469L239.474 88.1482C237.928 89.4547 236.421 90.7289 235.337 92.1662C234.222 93.6456 233.551 95.3042 233.741 97.3574C233.93 99.4016 234.746 101.006 235.779 102.408C236.446 103.312 237.21 104.14 237.953 104.945C238.355 105.381 238.751 105.81 239.122 106.241C240.185 107.476 241.059 108.741 241.37 110.275C241.679 111.807 241.432 113.626 240.213 115.977C238.71 118.877 236.471 120.403 233.945 121.333C232.025 122.04 229.948 122.399 227.901 122.754C227.246 122.867 226.594 122.98 225.952 123.104C223.311 123.611 220.829 124.299 219.005 125.967C217.176 127.64 216.029 130.279 216.011 134.643C215.993 139.012 217.271 141.746 219.238 143.546C221.199 145.339 223.829 146.19 226.482 146.828C227.165 146.992 227.849 147.142 228.523 147.29C230.483 147.72 232.367 148.134 233.94 148.829C234.994 149.295 235.898 149.884 236.585 150.682C237.27 151.479 237.743 152.49 237.925 153.809C238.319 156.69 237.305 158.885 235.597 160.684C233.884 162.488 231.477 163.888 229.093 165.166C228.707 165.373 228.321 165.577 227.938 165.779C225.972 166.819 224.105 167.805 222.786 168.899C221.996 169.553 221.392 170.254 221.081 171.039C220.769 171.829 220.758 172.691 221.134 173.656Z"
        fill="#DBDBDB"
        stroke="#C0C0C0"
        strokeWidth="0.25"
      />
      <path
        d="M193.557 185.913C193.719 185.882 193.864 185.793 193.965 185.663C194.066 185.533 194.117 185.37 194.107 185.205C194.049 184.22 193.615 182.937 193.115 181.447C192.03 178.215 190.68 174.192 192.299 171.066C193.225 169.281 194.41 167.652 195.666 165.927C197.75 163.063 199.906 160.101 200.842 156.307C202.754 148.62 200.658 142.73 198.818 137.525C197.477 133.736 196.32 130.463 196.961 127.214C197.494 124.509 199.178 123.632 201.307 122.521C203.519 121.379 206.023 120.061 207.872 116.495C209.668 113.029 209.291 110.943 208.934 108.925C208.557 106.826 208.167 104.657 210.332 100.482C212.159 96.9443 214.178 95.9182 216.307 94.8304C218.549 93.6829 220.87 92.5032 223.118 88.6235C227.319 81.3774 226.609 75.3704 226.091 70.9848C225.802 68.5392 225.574 66.6037 226.309 65.3472C228.051 62.3702 230.607 62.5926 230.725 62.6034C230.905 62.6232 231.085 62.5709 231.225 62.4581C231.366 62.3452 231.457 62.181 231.476 62.0016C231.496 61.8222 231.444 61.6423 231.331 61.5015C231.218 61.3606 231.054 61.2704 230.875 61.2506C230.731 61.2358 227.334 60.8967 225.137 64.6598C224.169 66.3123 224.421 68.4442 224.741 71.1449C225.236 75.3408 225.913 81.0816 221.942 87.9414C219.883 91.4775 217.853 92.5174 215.692 93.6185C213.466 94.7629 211.16 95.9235 209.128 99.8542C206.75 104.442 207.2 106.95 207.597 109.163C207.947 111.123 208.251 112.814 206.666 115.87C205.016 119.053 202.812 120.202 200.681 121.313C198.422 122.492 196.289 123.606 195.631 126.96C194.92 130.573 196.193 134.174 197.542 137.987C199.317 143.006 201.329 148.694 199.528 155.984C198.655 159.518 196.576 162.362 194.57 165.129C193.34 166.818 192.07 168.565 191.097 170.44C189.212 174.08 190.726 178.59 191.832 181.881C192.302 183.277 192.704 184.479 192.753 185.288C192.763 185.467 192.845 185.636 192.98 185.756C193.115 185.875 193.291 185.937 193.471 185.926L193.557 185.913Z"
        fill="white"
      />
      <path
        d="M253.142 228.133C232.416 233.379 214.281 232.602 200.83 226.023C187.377 219.442 178.59 207.049 176.579 189.018C193.533 178.743 210.137 180.569 223.775 188.943C237.401 197.311 248.067 212.219 253.142 228.133Z"
        fill="#EBEBEB"
        stroke="#C0C0C0"
        strokeWidth="0.25"
      />
      <path
        d="M243.802 224.523C243.943 224.494 244.072 224.422 244.169 224.315C244.266 224.209 244.326 224.075 244.342 223.932C244.358 223.789 244.328 223.644 244.256 223.519C244.185 223.394 244.076 223.295 243.944 223.237C232.341 218.062 217.429 209.908 204.268 202.715C193.39 196.769 183.115 191.151 176.719 188.333C176.637 188.294 176.548 188.273 176.458 188.269C176.367 188.266 176.277 188.28 176.192 188.312C176.107 188.344 176.03 188.392 175.964 188.454C175.898 188.517 175.846 188.591 175.809 188.674C175.772 188.757 175.753 188.847 175.751 188.937C175.75 189.028 175.766 189.118 175.8 189.202C175.834 189.286 175.884 189.362 175.948 189.427C176.011 189.491 176.087 189.542 176.171 189.577C182.517 192.371 192.763 197.976 203.615 203.906C216.797 211.111 231.737 219.28 243.388 224.475C243.518 224.534 243.663 224.551 243.802 224.523Z"
        fill="white"
      />
      <path d="M100.566 54.4358H93.5376V73.622H100.566V54.4358Z" fill="#D93E33" />
      <path
        d="M33.2346 82.5661L19.226 96.5747L24.3397 101.688L38.3483 87.6798L33.2346 82.5661Z"
        fill="#D93E33"
      />
      <path
        d="M24.1195 76.1002L12.7624 87.4573L20.5532 95.248L31.9102 83.891L24.1195 76.1002Z"
        fill="#FDF1F0"
      />
      <path
        d="M155.765 87.6794L169.774 101.688L174.888 96.5743L160.879 82.5657L155.765 87.6794Z"
        fill="#D93E33"
      />
      <path
        d="M162.204 83.8915L173.561 95.2485L181.352 87.4578L169.995 76.1007L162.204 83.8915Z"
        fill="#FDF1F0"
      />
      <path
        d="M97.0572 256.553C150.163 256.553 193.214 213.502 193.214 160.396C193.214 107.29 150.163 64.2388 97.0572 64.2388C43.9511 64.2388 0.900208 107.29 0.900208 160.396C0.900208 213.502 43.9511 256.553 97.0572 256.553Z"
        fill="#F19285"
      />
      <path
        d="M177.848 108.24C185.97 122.782 190.222 139.167 190.195 155.824C190.195 209.794 146.445 253.544 92.475 253.544C75.8187 253.571 59.4346 249.32 44.8932 241.197C60.4265 251.253 78.5427 256.59 97.0474 256.561C150.153 256.561 193.202 213.512 193.202 160.406C193.237 141.898 187.903 123.778 177.848 108.24Z"
        fill="#D93E33"
      />
      <path
        opacity="0.8"
        d="M15.469 160.395C15.469 115.334 51.9968 78.8064 97.0577 78.8064C117.965 78.7786 138.08 86.8063 153.224 101.222C145.61 93.1795 136.435 86.7762 126.259 82.4044C116.084 78.0326 105.123 75.7843 94.0487 75.7974C48.9897 75.7974 12.4619 112.327 12.4619 157.386C12.4486 168.461 14.6964 179.421 19.0675 189.596C23.4386 199.771 29.8411 208.947 37.8826 216.561C23.4676 201.418 15.4406 181.303 15.469 160.395Z"
        fill="#F5F5F6"
      />
      <path
        d="M97.0568 241.984C142.117 241.984 178.646 205.456 178.646 160.395C178.646 115.335 142.117 78.8066 97.0568 78.8066C51.9966 78.8066 15.4681 115.335 15.4681 160.395C15.4681 205.456 51.9966 241.984 97.0568 241.984Z"
        fill="white"
      />
      <path d="M97.6275 83.1194H96.4877V90.2601H97.6275V83.1194Z" fill="#C0C0C0" />
      <path
        d="M90.8899 83.3628L89.7545 83.4622L90.041 86.7379L91.1765 86.6386L90.8899 83.3628Z"
        fill="#C0C0C0"
      />
      <path
        d="M77.6066 85.6086L76.5057 85.9036L77.3568 89.0798L78.4577 88.7848L77.6066 85.6086Z"
        fill="#C0C0C0"
      />
      <path
        d="M64.9151 90.1226L63.8821 90.6042L65.2717 93.5844L66.3047 93.1027L64.9151 90.1226Z"
        fill="#C0C0C0"
      />
      <path
        d="M53.2007 96.7637L52.2671 97.4175L54.1532 100.111L55.0868 99.4573L53.2007 96.7637Z"
        fill="#C0C0C0"
      />
      <path
        d="M42.8193 105.344L42.0134 106.15L44.3385 108.475L45.1445 107.669L42.8193 105.344Z"
        fill="#C0C0C0"
      />
      <path
        d="M34.0823 115.609L33.4286 116.542L36.1222 118.429L36.7759 117.495L34.0823 115.609Z"
        fill="#C0C0C0"
      />
      <path
        d="M27.2627 127.217L26.781 128.25L29.7612 129.64L30.2429 128.607L27.2627 127.217Z"
        fill="#C0C0C0"
      />
      <path
        d="M22.5624 139.843L22.2674 140.944L25.4436 141.795L25.7386 140.694L22.5624 139.843Z"
        fill="#C0C0C0"
      />
      <path
        d="M20.1246 153.093L20.0253 154.228L23.301 154.515L23.4004 153.379L20.1246 153.093Z"
        fill="#C0C0C0"
      />
      <path
        d="M23.301 166.276L20.0253 166.562L20.1246 167.698L23.4004 167.411L23.301 166.276Z"
        fill="#C0C0C0"
      />
      <path
        d="M25.4436 178.992L22.2674 179.843L22.5624 180.944L25.7386 180.093L25.4436 178.992Z"
        fill="#C0C0C0"
      />
      <path
        d="M29.7657 191.142L26.7852 192.531L27.2668 193.565L30.2472 192.175L29.7657 191.142Z"
        fill="#C0C0C0"
      />
      <path
        d="M36.1208 202.367L33.4272 204.253L34.0809 205.187L36.7745 203.301L36.1208 202.367Z"
        fill="#C0C0C0"
      />
      <path
        d="M44.3357 212.307L42.0106 214.632L42.8165 215.438L45.1416 213.113L44.3357 212.307Z"
        fill="#C0C0C0"
      />
      <path
        d="M54.1508 220.679L52.2657 223.373L53.1996 224.026L55.0847 221.332L54.1508 220.679Z"
        fill="#C0C0C0"
      />
      <path
        d="M65.2723 227.198L63.8821 230.178L64.915 230.66L66.3052 227.68L65.2723 227.198Z"
        fill="#C0C0C0"
      />
      <path
        d="M77.3568 231.716L76.5057 234.892L77.6066 235.187L78.4577 232.011L77.3568 231.716Z"
        fill="#C0C0C0"
      />
      <path
        d="M90.0447 234.061L89.7587 237.337L90.8941 237.436L91.1802 234.16L90.0447 234.061Z"
        fill="#C0C0C0"
      />
      <path
        d="M104.071 234.051L102.936 234.15L103.222 237.426L104.358 237.327L104.071 234.051Z"
        fill="#C0C0C0"
      />
      <path
        d="M116.753 231.715L115.652 232.01L116.503 235.186L117.604 234.891L116.753 231.715Z"
        fill="#C0C0C0"
      />
      <path
        d="M128.845 227.204L127.812 227.686L129.202 230.665L130.235 230.184L128.845 227.204Z"
        fill="#C0C0C0"
      />
      <path
        d="M139.954 220.694L139.02 221.347L140.905 224.041L141.839 223.387L139.954 220.694Z"
        fill="#C0C0C0"
      />
      <path
        d="M149.776 212.309L148.97 213.115L151.295 215.44L152.101 214.634L149.776 212.309Z"
        fill="#C0C0C0"
      />
      <path
        d="M157.988 202.364L157.334 203.298L160.028 205.184L160.682 204.251L157.988 202.364Z"
        fill="#C0C0C0"
      />
      <path
        d="M164.36 191.164L163.878 192.197L166.858 193.587L167.34 192.554L164.36 191.164Z"
        fill="#C0C0C0"
      />
      <path
        d="M168.679 179.006L168.384 180.107L171.561 180.958L171.856 179.858L168.679 179.006Z"
        fill="#C0C0C0"
      />
      <path
        d="M171.831 166.015L171.728 167.155L175.016 167.451L175.119 166.311L171.831 166.015Z"
        fill="#C0C0C0"
      />
      <path
        d="M173.992 153.082L170.716 153.368L170.816 154.504L174.091 154.218L173.992 153.082Z"
        fill="#C0C0C0"
      />
      <path
        d="M171.552 139.843L168.376 140.694L168.671 141.795L171.847 140.944L171.552 139.843Z"
        fill="#C0C0C0"
      />
      <path
        d="M166.849 127.231L163.869 128.621L164.351 129.654L167.331 128.264L166.849 127.231Z"
        fill="#C0C0C0"
      />
      <path
        d="M159.838 116.183L157.142 118.057L157.791 118.991L160.488 117.117L159.838 116.183Z"
        fill="#C0C0C0"
      />
      <path
        d="M151.297 105.35L148.971 107.675L149.777 108.481L152.102 106.156L151.297 105.35Z"
        fill="#C0C0C0"
      />
      <path
        d="M140.913 96.7693L139.027 99.4629L139.96 100.117L141.846 97.4231L140.913 96.7693Z"
        fill="#C0C0C0"
      />
      <path
        d="M129.194 90.1136L127.804 93.0935L128.837 93.5754L130.227 90.5955L129.194 90.1136Z"
        fill="#C0C0C0"
      />
      <path
        d="M116.507 85.6072L115.656 88.7834L116.757 89.0784L117.608 85.9022L116.507 85.6072Z"
        fill="#C0C0C0"
      />
      <path
        d="M103.222 83.3612L102.936 86.637L104.071 86.7363L104.358 83.4606L103.222 83.3612Z"
        fill="#C0C0C0"
      />
      <path
        d="M84.1985 84.1969L83.076 84.3948L84.316 91.427L85.4384 91.229L84.1985 84.1969Z"
        fill="#C0C0C0"
      />
      <path
        d="M71.0616 87.7441L69.9902 88.1316L72.418 94.8438L73.4894 94.4563L71.0616 87.7441Z"
        fill="#C0C0C0"
      />
      <path
        d="M58.9127 93.1867L57.9257 93.7566L61.496 99.9406L62.4831 99.3707L58.9127 93.1867Z"
        fill="#C0C0C0"
      />
      <path
        d="M47.8216 100.832L46.9485 101.564L51.5384 107.035L52.4115 106.302L47.8216 100.832Z"
        fill="#C0C0C0"
      />
      <path
        d="M38.2253 110.289L37.4927 111.162L42.9628 115.752L43.6954 114.879L38.2253 110.289Z"
        fill="#C0C0C0"
      />
      <path
        d="M30.4176 121.262L29.8477 122.249L36.0317 125.819L36.6016 124.832L30.4176 121.262Z"
        fill="#C0C0C0"
      />
      <path
        d="M24.6366 133.431L24.2467 134.502L30.9568 136.944L31.3466 135.873L24.6366 133.431Z"
        fill="#C0C0C0"
      />
      <path
        d="M21.0549 146.419L20.8569 147.541L27.8891 148.781L28.087 147.659L21.0549 146.419Z"
        fill="#C0C0C0"
      />
      <path d="M26.9215 159.825H19.7809V160.964H26.9215V159.825Z" fill="#C0C0C0" />
      <path
        d="M27.8889 172.011L20.8569 173.252L21.055 174.374L28.087 173.133L27.8889 172.011Z"
        fill="#C0C0C0"
      />
      <path
        d="M30.9488 183.85L24.2383 186.292L24.628 187.363L31.3384 184.922L30.9488 183.85Z"
        fill="#C0C0C0"
      />
      <path
        d="M36.0253 194.978L29.8407 198.547L30.4104 199.534L36.595 195.965L36.0253 194.978Z"
        fill="#C0C0C0"
      />
      <path
        d="M42.9704 205.029L37.5011 209.62L38.2339 210.493L43.7032 205.902L42.9704 205.029Z"
        fill="#C0C0C0"
      />
      <path
        d="M51.5361 213.761L46.9471 219.231L47.8203 219.964L52.4093 214.493L51.5361 213.761Z"
        fill="#C0C0C0"
      />
      <path
        d="M61.4978 220.829L57.9285 227.014L58.9157 227.584L62.4849 221.399L61.4978 220.829Z"
        fill="#C0C0C0"
      />
      <path
        d="M72.5338 226.114L70.0927 232.824L71.1638 233.214L73.6049 226.504L72.5338 226.114Z"
        fill="#C0C0C0"
      />
      <path
        d="M83.0031 228.993L81.7892 235.991L82.9062 236.184L84.1201 229.187L83.0031 228.993Z"
        fill="#C0C0C0"
      />
      <path d="M97.6275 230.529H96.4877V237.669H97.6275V230.529Z" fill="#C0C0C0" />
      <path
        d="M109.796 229.367L108.673 229.565L109.913 236.597L111.035 236.399L109.796 229.367Z"
        fill="#C0C0C0"
      />
      <path
        d="M121.574 226.113L120.503 226.503L122.945 233.213L124.016 232.823L121.574 226.113Z"
        fill="#C0C0C0"
      />
      <path
        d="M132.618 220.847L131.63 221.417L135.201 227.601L136.188 227.031L132.618 220.847Z"
        fill="#C0C0C0"
      />
      <path
        d="M142.627 214.889L141.749 215.618L146.319 221.116L147.197 220.387L142.627 214.889Z"
        fill="#C0C0C0"
      />
      <path
        d="M151.148 205.035L150.416 205.908L155.886 210.498L156.618 209.625L151.148 205.035Z"
        fill="#C0C0C0"
      />
      <path
        d="M158.08 194.967L157.51 195.954L163.694 199.524L164.264 198.537L158.08 194.967Z"
        fill="#C0C0C0"
      />
      <path
        d="M163.158 183.846L162.768 184.917L169.478 187.36L169.868 186.289L163.158 183.846Z"
        fill="#C0C0C0"
      />
      <path
        d="M166.225 172.012L166.027 173.134L173.059 174.374L173.257 173.252L166.225 172.012Z"
        fill="#C0C0C0"
      />
      <path d="M174.332 159.825H167.192V160.964H174.332V159.825Z" fill="#C0C0C0" />
      <path
        d="M173.062 146.409L166.03 147.651L166.228 148.773L173.26 147.532L173.062 146.409Z"
        fill="#C0C0C0"
      />
      <path
        d="M169.48 133.42L162.769 135.862L163.159 136.933L169.87 134.492L169.48 133.42Z"
        fill="#C0C0C0"
      />
      <path
        d="M163.695 121.281L157.51 124.851L158.08 125.838L164.264 122.268L163.695 121.281Z"
        fill="#C0C0C0"
      />
      <path
        d="M155.886 110.279L150.416 114.868L151.148 115.741L156.619 111.152L155.886 110.279Z"
        fill="#C0C0C0"
      />
      <path
        d="M146.295 100.841L141.704 106.31L142.577 107.043L147.168 101.574L146.295 100.841Z"
        fill="#C0C0C0"
      />
      <path
        d="M135.193 93.1772L131.623 99.3618L132.611 99.9315L136.18 93.7469L135.193 93.1772Z"
        fill="#C0C0C0"
      />
      <path
        d="M122.955 87.5867L120.51 94.2959L121.581 94.6861L124.025 87.9769L122.955 87.5867Z"
        fill="#C0C0C0"
      />
      <path
        d="M109.196 84.5027L107.982 91.5005L109.099 91.6942L110.313 84.6964L109.196 84.5027Z"
        fill="#C0C0C0"
      />
      <path
        d="M160.928 137.149C151.433 111.064 126.421 92.4473 97.0567 92.4473V160.397L160.928 137.149Z"
        fill="#EBEBEB"
      />
      <path
        d="M115.44 26.719H78.6748C77.0781 26.719 75.7836 28.0134 75.7836 29.6102V51.4654C75.7836 53.0621 77.0781 54.3566 78.6748 54.3566H115.44C117.037 54.3566 118.331 53.0621 118.331 51.4654V29.6102C118.331 28.0134 117.037 26.719 115.44 26.719Z"
        fill="#F0F0F0"
      />
      <path d="M115.256 26.719H113.844V54.3566H115.256V26.719Z" fill="#F4E1DF" />
      <path d="M111.368 26.719H109.957V54.3566H111.368V26.719Z" fill="#F4E1DF" />
      <path d="M107.48 26.719H106.069V54.3566H107.48V26.719Z" fill="#F4E1DF" />
      <path d="M103.594 26.719H102.183V54.3566H103.594V26.719Z" fill="#F4E1DF" />
      <path d="M99.7071 26.719H98.2957V54.3566H99.7071V26.719Z" fill="#F4E1DF" />
      <path d="M95.8186 26.719H94.4072V54.3566H95.8186V26.719Z" fill="#F4E1DF" />
      <path d="M91.9315 26.719H90.5201V54.3566H91.9315V26.719Z" fill="#F4E1DF" />
      <path d="M88.043 26.719H86.6316V54.3566H88.043V26.719Z" fill="#F4E1DF" />
      <path d="M84.1573 26.719H82.7458V54.3566H84.1573V26.719Z" fill="#F4E1DF" />
      <path d="M80.2688 26.719H78.8573V54.3566H80.2688V26.719Z" fill="#F4E1DF" />
      <path
        d="M161.208 137.046C157.435 136.113 153.501 137.34 147.597 139.49L96.2503 158.173L97.8631 162.607L149.21 143.926C155.116 141.774 158.917 140.186 161.208 137.046Z"
        fill="#A3A5AE"
      />
      <path
        d="M97.0574 169.028C101.825 169.028 105.689 165.163 105.689 160.396C105.689 155.629 101.825 151.764 97.0574 151.764C92.2901 151.764 88.4255 155.629 88.4255 160.396C88.4255 165.163 92.2901 169.028 97.0574 169.028Z"
        fill="#A3A5AE"
      />
      <path
        d="M51.7118 114.242L50.9058 115.048L107.705 171.847L108.51 171.041L51.7118 114.242Z"
        fill="#D93E33"
      />
      <path
        d="M97.0572 162.917C98.4494 162.917 99.578 161.788 99.578 160.396C99.578 159.004 98.4494 157.875 97.0572 157.875C95.665 157.875 94.5364 159.004 94.5364 160.396C94.5364 161.788 95.665 162.917 97.0572 162.917Z"
        fill="white"
      />
      <path d="M119.511 177.556H74.6036V187.233H119.511V177.556Z" fill="#EBEBEB" />
      <path d="M110.476 190.722H83.6379V193.993H110.476V190.722Z" fill="#EBEBEB" />
    </svg>
  );
}
